import { render, staticRenderFns } from "./ModalSamples.vue?vue&type=template&id=3be51da4&scoped=true&"
import script from "./ModalSamples.vue?vue&type=script&lang=js&"
export * from "./ModalSamples.vue?vue&type=script&lang=js&"
import style0 from "./ModalSamples.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalSamples.vue?vue&type=style&index=1&id=3be51da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be51da4",
  null
  
)

export default component.exports